'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parts = ['container', 'item', 'icon'];
var baseStyleContainer = {
  display: 'flex',
  lineHeight: 'none'
};
var baseStyleItem = {
  display: 'inline-block'
};
var baseStyleIcon = {};
var baseStyle = {
  container: baseStyleContainer,
  item: baseStyleItem,
  icon: baseStyleIcon
};
var sizes = {
  sm: {
    icon: {
      w: 2,
      h: 2
    }
  },
  md: {
    icon: {
      w: 4,
      h: 4
    }
  },
  lg: {
    icon: {
      w: 6,
      h: 6
    }
  }
};
var defaultProps = {
  size: 'md'
};
var Rating = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Rating;